import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import structuredData from "./utilities/structuredData";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { setAnalyticsConfig } from "./utilities/setAnalyticsConfig";
import { setSEOMetaTags } from "./utilities/setSEOMetaTags";
import { setCookieConsentConfig } from "./utilities/setCookieConsentConfig";
import { store } from "./store/store";
import { msalConfig } from "./utilities/msalAuthConfig";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import "@ms-mwf/moray/dist/css/main.css";
import "@ms-onecloud/moray-reimagine/dist/css/main.css";
import "@ms-onecloud/moray-reimagine/dist/css/themes/main-azure.css";

import "./i18next";

import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig());

function structuredDataAtTopOfHtml() {
  const existingScript = document.getElementById("structured-data-jsonld");
  existingScript?.remove();

  const script = document.createElement("script");
  script.id = "structured-data-jsonld";
  script.type = "application/ld+json";
  script.text = JSON.stringify(structuredData);
  // prepend to add the structured data to the top of the HTML head to get crawled by search engines
  document.head.prepend(script);
}

// Block rendering until MSAL is ready.
async function bootstrap() {
  await msalInstance.initialize();

  // REQUIRED if using redirect or MsalAuthenticationTemplate
  await msalInstance.handleRedirectPromise();

  setAnalyticsConfig();
  // setSEOMetaTags();
  setCookieConsentConfig();
  structuredDataAtTopOfHtml();

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );

  reportWebVitals();
}

bootstrap();